import { AuthGuard } from "../../../auth/helpers";
import { BargainingListComponent } from "./pages/list/bargaining-list.component";
import { CreateBargainingComponent } from "./pages/create/create-bargaining.component";
import { SelectBargainingComponent } from "./pages/select/select-bargaining.component";
import { EditBargainingComponent } from "./pages/edit/edit-bargaining.component";
import { IRoute } from "app/auth/models/utils-interfaces";

const bargainingRoutes: IRoute[] = [
  {
    path: "dashboard/bargaining-list",
    component: BargainingListComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_bargaining_list",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/create-bargaining/:user_identifier/:id",
    component: CreateBargainingComponent,
    canActivate: [AuthGuard],
    capability: "create_bargaining",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/create-bargaining",
    component: SelectBargainingComponent,
    canActivate: [AuthGuard],
    capability: "create_bargaining",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/edit-bargaining/:id",
    component: EditBargainingComponent,
    canActivate: [AuthGuard],
    capability: "edit_bargaining",
    data: { animation: "flatpickr" },
  },
];
export default bargainingRoutes;
